<template>
    <v-navigation-drawer
      v-model="$store.state.drawer"
      absolute
      dark
      class="hidden-print-only body-1"
      id="va-drawer"
      color="primary"
    >
      <v-list-item>
        <v-list-item-avatar>
          <!-- <v-img :src="$store.state.applogo"></v-img> -->
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title><v-img :src="$store.state.applogo" width="110px"></v-img></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      
      <v-list dense>  
      <v-list-item-group color="fff" v-if="MAIN.length > 0">
          <v-list-item
          v-for="(item, i) in MAIN"
          :key="i + '-main'"
          @click="$router.push(item.path).catch(err => {})"
        >
          <v-list-item-icon>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{item.title}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
        <v-expansion-panels >
           <v-expansion-panel>
            <v-expansion-panel-header class="pa-3" v-if="OPERATIONS.length > 0"><span class="sm-font">OPERATIONS</span></v-expansion-panel-header>
            <v-expansion-panel-content class="pa-0 elevation-0">
              <v-list-item
                  v-for="(item, i) in OPERATIONS"
                  :key="i + '-admin'"
                  @click="$router.push(item.path).catch(err => {})"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
            </v-expansion-panel-content>
            </v-expansion-panel>

            
          <v-expansion-panel >
            <v-expansion-panel-header  class="pa-3" v-if="ACCOUNTING.length > 0"><span class="sm-font">ACCOUNTING</span></v-expansion-panel-header>
            <v-expansion-panel-content class="pa-0">
              <v-list-item
                 v-for="(item, i) in ACCOUNTING"
                :key="i + '-acc'"
                @click="$router.push(item.path).catch(err => {})"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
            </v-expansion-panel-content>
           </v-expansion-panel>

           <v-expansion-panel>
            <v-expansion-panel-header  class="pa-3"  v-if="REPORTS.length > 0"><span class="sm-font">REPORTS</span></v-expansion-panel-header>
            <v-expansion-panel-content class="pa-0">
              <v-list-item
                 v-for="(item, i) in REPORTS"
                :key="i + '-reports'"
                @click="$router.push(item.path).catch(err => {})"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
            </v-expansion-panel-content>
          </v-expansion-panel>

           <v-expansion-panel>
            <v-expansion-panel-header  class="pa-3"  v-if="APPS.length > 0"><span class="sm-font">APPS</span></v-expansion-panel-header>
            <v-expansion-panel-content class="pa-0">
              <v-list-item
                 v-for="(item, i) in APPS"
                :key="i + '-apps'"
                @click="$router.push(item.path).catch(err => {})"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header class="pa-3" v-if="ADMIN.length > 0"><span class="sm-font">ADMIN</span></v-expansion-panel-header>
            <v-expansion-panel-content class="pa-0 elevation-0">
              <v-list-item
                  v-for="(item, i) in ADMIN"
                  :key="i + '-admin'"
                  @click="$router.push(item.path).catch(err => {})"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
            </v-expansion-panel-content>
            </v-expansion-panel>


          
          
         
          
        </v-expansion-panels>


      </v-list-item-group>
    </v-list>
    </v-navigation-drawer>

</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data () {
      return {
        item: 1,
        mini: true,
      }
    },
    computed: {
        MAIN(){
          return this.$store.state.allowed_menus.mainmenu
        },
        OPERATIONS(){
           return this.$store.state.allowed_menus.operations
        },
        ADMIN(){
           return this.$store.state.allowed_menus.admin
        },
        APPS(){
          return this.$store.state.allowed_menus.apps
        },
        REPORTS(){
          return this.$store.state.allowed_menus.reports
        },
        ACCOUNTING(){
          return this.$store.state.allowed_menus.accounting
        }
    },
    methods: {
      ...mapMutations(['setDrawer']),
    }
  }
</script>